import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

class ContraReciboReporte extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('date', 'inicio', 'Inicio', false, [Validators.required], 6),
        Form.Field('date', 'fin', 'Fin', false, [Validators.required], 6),
        Form.Field('radio', 'fecha_clase', 'Fecha', false, [Validators.required], 6, [
          { Value: 'factura', Label: 'Fecha factura' },
          { Value: 'recibo', Label: 'Fecha contra recibo' }
        ]),
        Form.Field('select', 'id_sucursal', 'Sucursal destino', '', [], 6),
      ], ['Guardar'], 'Contra recibos'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    let Res = await Http.get('contra-recibo/reporte/form');
    console.log(Res);
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
    }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.setState({ loading: true });
    let params = {
      ...vals,
    }
    try {
      let Res = await Http.get(`contra-recibo/reporte?${objectAsParams(params)}`, true, 'arraybuffer');
      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'contra_recibos.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // if (!Res.error) {

      // }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ContraReciboReporte)
